// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dowload-button{
    margin-left: 0.2rem;
    border: none;
    color: white;
}

.dowload-button:hover{
    background-color: rgb(0, 80, 142);
    transition: 0.2s;
}

.dowload-button:active{
    background-color: rgb(34, 103, 150);
}`, "",{"version":3,"sources":["webpack://./src/css/renderWorks.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".dowload-button{\n    margin-left: 0.2rem;\n    border: none;\n    color: white;\n}\n\n.dowload-button:hover{\n    background-color: rgb(0, 80, 142);\n    transition: 0.2s;\n}\n\n.dowload-button:active{\n    background-color: rgb(34, 103, 150);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
